/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tourhelp_NoneInputs */

const en_tourhelp_none = /** @type {(inputs: Tourhelp_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No tour for this page yet`)
};

/** @type {(inputs: Tourhelp_NoneInputs) => LocalizedString} */
const ar_tourhelp_none = en_tourhelp_none;

/** @type {(inputs: Tourhelp_NoneInputs) => LocalizedString} */
const he_tourhelp_none = en_tourhelp_none;

/** @type {(inputs: Tourhelp_NoneInputs) => LocalizedString} */
const ur_tourhelp_none = en_tourhelp_none;

/** @type {(inputs: Tourhelp_NoneInputs) => LocalizedString} */
const es_tourhelp_none = en_tourhelp_none;

/** @type {(inputs: Tourhelp_NoneInputs) => LocalizedString} */
const fr_tourhelp_none = en_tourhelp_none;

/** @type {(inputs: Tourhelp_NoneInputs) => LocalizedString} */
const de_tourhelp_none = en_tourhelp_none;

/** @type {(inputs: Tourhelp_NoneInputs) => LocalizedString} */
const pt_tourhelp_none = en_tourhelp_none;

/** @type {(inputs: Tourhelp_NoneInputs) => LocalizedString} */
const hi_tourhelp_none = en_tourhelp_none;

/** @type {(inputs: Tourhelp_NoneInputs) => LocalizedString} */
const bn_tourhelp_none = en_tourhelp_none;

/**
* | output |
* | --- |
* | "No tour for this page yet" |
*
* @param {Tourhelp_NoneInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const tourhelp_none = /** @type {((inputs?: Tourhelp_NoneInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tourhelp_NoneInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_tourhelp_none(inputs)
	if (locale === "he") return he_tourhelp_none(inputs)
	if (locale === "ur") return ur_tourhelp_none(inputs)
	if (locale === "es") return es_tourhelp_none(inputs)
	if (locale === "fr") return fr_tourhelp_none(inputs)
	if (locale === "de") return de_tourhelp_none(inputs)
	if (locale === "pt") return pt_tourhelp_none(inputs)
	if (locale === "hi") return hi_tourhelp_none(inputs)
	if (locale === "bn") return bn_tourhelp_none(inputs)
	return /** @type {LocalizedString} */ ("No tour for this page yet")
});